import { clsx } from 'clsx';
import type { ComponentPropsWithRef } from 'react';

export interface InputProps extends ComponentPropsWithRef<'input'> {
  /** Marks the control invalid (`aria-invalid` + error border). Pair it with `<FieldError>` via `aria-describedby`. */
  invalid?: boolean;
}

/** 48 px single-line field on the raised surface; 16 px text so iOS never zooms on focus. */
export function Input({ invalid, className, ...props }: InputProps) {
  return (
    <input className={clsx('field', className)} aria-invalid={invalid || undefined} {...props} />
  );
}
